/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { Button, IconButton, styled, Tooltip } from '@mui/material';
import { createInterviews } from '../../Repositories';
import { ToolbarContainer } from '../../Container';

import { useURLQuery } from '../../Common/Hook/urlQuery';
import { useThemeMode } from '../../themeMode';

import {
  AGENCIES_ENDPOINT,
  AppContext,
  APPLICANT_DETAILS_ENDPOINT,
  APPLICATION_OVERVIEW_ENDPOINT,
  ApplicationContext,
  APPLICATIONS_BETA_ENDPOINT,
  APPLICATIONS_DETAILS_ENDPOINT,
  APPLICATIONS_ENDPOINT,
  AuthContext,
  CALENDAR_ENDPOINT,
  DASHBOARD_ENDPOINT,
  HR_REPORTS_ENDPOINT,
  INTERVIEWS_ENDPOINT,
  LEVELS_ENDPOINT,
  MY_OPEN_POSITIONS_ENDPOINT,
  OtherContext,
  PANEL_REPORTS_ENDPOINT,
  PANELS_ENDPOINT,
  POSITIONS_ENDPOINT,
  PRE_SCREENING,
  PREVIOUS_INTERVIEWS_ENDPOINT,
  REFERRALS_ENDPOINT,
  REPORTS_ENDPOINT,
  RESUME_SCREENING,
  ROLES,
  SETTINGS_ENDPOINT,
  SKILLS_ENDPOINT,
  STREAMS_ENDPOINT,
  TABULAR_EVENTS_ENDPOINT,
  TEAM_REQUIREMENTS_END_POINT,
  TEAMS_ENDPOINT,
  TEMPLATES_ENDPOINT,
  TITLES,
  USER_SETTINGS_ENDPOINT,
  USERS_ENDPOINT,
} from '../../constants';

import { AlertError } from '../Error';
import SimpleLoader from '../Loader/SimpleLoader';
import LogoutButton from '../LogInAndLogout/LogoutButton';
import Notifications from '../Notifications';
import Search from '../SearchBox';

import './toolBar.css';

const interviewsApi = createInterviews();
const headingName = {
  ['/']: TITLES.DASHBOARD,
  [DASHBOARD_ENDPOINT]: TITLES.DASHBOARD,
  [POSITIONS_ENDPOINT]: TITLES.POSITIONS,
  [APPLICATIONS_ENDPOINT]: TITLES.APPLICATIONS,
  [APPLICATIONS_BETA_ENDPOINT]: TITLES.APPLICATIONS_BETA,
  [APPLICATION_OVERVIEW_ENDPOINT]: TITLES.APPLICATION_OVERVIEW,
  [REFERRALS_ENDPOINT]: TITLES.REFERRALS,
  [CALENDAR_ENDPOINT]: TITLES.CALENDAR,
  [RESUME_SCREENING]: TITLES.RESUME_SCREENING,
  [PRE_SCREENING]: TITLES.PRE_SCREENING,
  [TEAMS_ENDPOINT]: TITLES.TEAMS,
  [TEAM_REQUIREMENTS_END_POINT]: TITLES.REQUIREMENT,
  [USERS_ENDPOINT]: TITLES.USERS,
  [LEVELS_ENDPOINT]: TITLES.LEVELS,
  [SKILLS_ENDPOINT]: TITLES.SKILLS,
  [STREAMS_ENDPOINT]: TITLES.STREAMS,
  [TEMPLATES_ENDPOINT]: TITLES.TEMPLATES,
  [AGENCIES_ENDPOINT]: TITLES.AGENCIES,
  [HR_REPORTS_ENDPOINT]: TITLES.HR_REPORTS,
  [INTERVIEWS_ENDPOINT]: TITLES.INTERVIEWS,
  [MY_OPEN_POSITIONS_ENDPOINT]: TITLES.MY_OPEN_POSITIONS,
  [SETTINGS_ENDPOINT]: TITLES.SETTINGS,
  [PANEL_REPORTS_ENDPOINT]: TITLES.PANEL_REPORTS,
  [APPLICANT_DETAILS_ENDPOINT]: TITLES.APPLICANT_DETAILS,
  [TABULAR_EVENTS_ENDPOINT]: TITLES.TABULAR_CALENDAR,
  [PANELS_ENDPOINT]: TITLES.PANELS,
  [USER_SETTINGS_ENDPOINT]: TITLES.USER_SETTINGS,
  [REPORTS_ENDPOINT]: TITLES.PANEL_REPORTS,
};

const respectiveRoles = {
  [DASHBOARD_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.AGENCY,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [POSITIONS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.AGENCY,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [APPLICATIONS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [APPLICATIONS_BETA_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [APPLICATION_OVERVIEW_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.TENANT_OWNER,
  ],
  [REFERRALS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.AGENCY,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [CALENDAR_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [RESUME_SCREENING]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.HIRING_MANAGER, ROLES.TENANT_OWNER],
  [PRE_SCREENING]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.HR, ROLES.TENANT_OWNER],
  [TEAMS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.TENANT_OWNER,
  ],
  [TEAM_REQUIREMENTS_END_POINT]: [ROLES.ADMIN, ROLES.HIRING_MANAGER, ROLES.HR, ROLES.TENANT_OWNER],
  [USERS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [LEVELS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [SKILLS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [STREAMS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [TEMPLATES_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  [AGENCIES_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [HR_REPORTS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [INTERVIEWS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.AGENCY,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [MY_OPEN_POSITIONS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.TENANT_OWNER,
    ROLES.HR,
  ],
  [SETTINGS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_OWNER],
  [PANEL_REPORTS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.HR, ROLES.TENANT_OWNER],
  [APPLICANT_DETAILS_ENDPOINT]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.HR, ROLES.TENANT_OWNER],
  [TABULAR_EVENTS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
  [USER_SETTINGS_ENDPOINT]: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.HIRING_MANAGER,
    ROLES.HR,
    ROLES.USER,
    ROLES.TENANT_OWNER,
  ],
};

/**
 * function is ToolBar component which will return toolbar for all the pages
 * @function ToolBarUI
 */

// Styled component for the logo header to match DrawerHeader styling
const LogoHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  justifyContent: 'flex-start',
  backgroundColor: 'var(--hm-surface)',
  color: 'var(--hm-text)',
  transition: 'background-color var(--hm-transition), color var(--hm-transition)',
}));

const HeaderText = styled('span')(({ theme }) => ({
  color: 'var(--hm-text)',
  fontWeight: '700',
  fontSize: theme.spacing(3),
  lineHeight: '20px',
}));

export function BulkUploadHeading({ bulkUpload }) {
  return (
    <div className="flex gap-3">
      <p>Bulk Upload- Failed Records</p>
      {bulkUpload && <SimpleLoader size={30} />}
    </div>
  );
}

export function ToolBarUI({ teamData, userData, postServices, positionList }) {
  const routerLocation = useLocation();
  const location = routerLocation.pathname;
  const urlQuery = useURLQuery();
  const navigate = useNavigate();
  const { userName, teamName } = routerLocation.state ?? {};
  const positionID = urlQuery.get('positionID');
  const userID = urlQuery.get('userID');
  const { isFullScreen } = useContext(OtherContext);
  const { search, setSearch } = useContext(ApplicationContext);
  const { userInfo } = useContext(AuthContext);
  const { isDarkMode, toggleTheme } = useThemeMode();

  const role = userInfo?.roles && userInfo?.roles[0];
  const totalPositionsData = positionList?.data?.data || [];
  const positionData = totalPositionsData.filter(
    (position) => position.id === Number(positionID)
  )[0];

  const initialSearch = urlQuery.get('searchParam') || search.searchValue;
  const calendarView = urlQuery.get('view') || 'tabular';
  const [errorMessage, setErrorMessage] = useState('');
  /**
   * track bulk upload progress
   * @type {boolean}
   */
  /**
   * open bulk-upload modal
   * @type {boolean}
   */

  useEffect(() => {
    if (!search.searchValue) return;

    const searchValue = search.searchValue.trim();

    const runSearch = async () => {
      if (searchValue.length === 6) {
        try {
          const data = await interviewsApi.getInterviewsBySubjectId(searchValue);

          if (data?.data?.length > 0) {
            const interview = data.data[0];

            navigate(
              `${APPLICATIONS_ENDPOINT}/${interview.application.id}?interviewID=${interview.basicInfo.id}`
            );
            return;
          }
        } catch (error) {
          console.error('Failed to fetch interview by subjectID', error);
        }
      }
      navigate({
        pathname: APPLICATIONS_ENDPOINT,
        search: `searchParam=${searchValue}`,
      });
    };

    runSearch();
  }, [search.searchValue]);

  useEffect(() => {
    if (userData && userData?.isLoading === false && userData?.calendarStatus) {
      setErrorMessage(
        userData?.calendarStatus !== 'ACTIVE' ? 'User token is not set or expired!' : ''
      );
    }
  }, [userData?.isLoading]);
  const handleOnFilterChange = (updatedFilters) => {
    setSearch((prev) => ({ ...prev, ...updatedFilters }));
  };

  useEffect(() => {
    if (location !== APPLICATIONS_ENDPOINT) {
      setSearch((prevFilters) => ({ ...prevFilters, searchValue: '' }));
    } else setSearch((prevFilters) => ({ ...prevFilters, searchValue: initialSearch || '' }));
  }, [location]);

  const finalPanelName =
    (location === INTERVIEWS_ENDPOINT || location === PREVIOUS_INTERVIEWS_ENDPOINT) &&
    'Panel Interviews';

  const finalTeamName =
    location === TEAM_REQUIREMENTS_END_POINT
      ? teamName || teamData?.data?.name || ''
      : location === PANELS_ENDPOINT && headingName[location];

  const finalPositionName =
    location === APPLICATIONS_DETAILS_ENDPOINT && (positionData?.title || '');

  const handleSwitch = () => {
    const nextView = calendarView === 'tabular' ? 'Day' : 'tabular';
    urlQuery.set('view', nextView);
    navigate({ pathname: CALENDAR_ENDPOINT, search: urlQuery.toString() });
  };

  return (
    <div className={`main-container-toolbar ${isFullScreen ? 'sidebar-open' : ''}`}>
      <div className="head-text__heading">
        {!isFullScreen && (
          <LogoHeader>
            <Link to={DASHBOARD_ENDPOINT} className="link" id="hiring-motion-menu">
              <HeaderText>
                <span className="hr-name">Hiring</span>
                <span className="dashboard-name"> Motion</span>
              </HeaderText>
            </Link>
          </LogoHeader>
        )}
        <h1 className="head-text">
          {finalPanelName}
          {finalPositionName}
          {finalTeamName}
          {finalTeamName && ' '}
          {location !== INTERVIEWS_ENDPOINT &&
            (location === PANELS_ENDPOINT ? '' : headingName[location])}
        </h1>
      </div>
      {location === CALENDAR_ENDPOINT && (
        <Button
          className="font-semibold"
          style={{
            border: '1.5px solid var(--hm-primary, #229987)',
            padding: '6px 14px',
            borderRadius: '10px',
            marginLeft: '1.25rem',
            marginRight: 'auto',
            textTransform: 'none',
            fontSize: '0.875rem',
            height: '38px',
          }}
          onClick={handleSwitch}
        >
          {calendarView === 'tabular' ? 'Calendar View' : 'Tabular View'}
        </Button>
      )}
      <div className="toolbar-item-container">
        {role !== ROLES.AGENCY && (
          <div className="search">
            <Search
              filterValues={search}
              setFilterValues={handleOnFilterChange}
              placeholder="Search name, email, phone..."
              hideMinChars={true}
            />
          </div>
        )}
        <Notifications />
        <Tooltip title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
          <IconButton aria-label="toggle theme" onClick={toggleTheme}>
            {isDarkMode ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
          </IconButton>
        </Tooltip>
        <OtherContext.Provider value={{ userData: userData?.data, postServices }}>
          <LogoutButton />
        </OtherContext.Provider>

        {errorMessage && (
          <AlertError message={errorMessage} handleClose={() => setErrorMessage('')} />
        )}
      </div>
    </div>
  );
}

export default function ToolBarWrapper(props) {
  return (
    <ToolbarContainer {...props}>
      <ToolBarUI />
    </ToolbarContainer>
  );
}
